import type { FC, ReactNode } from 'react'

import Logo from '@/components/landing/logo'
import { navLinks, siteConfig } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-white/10'>
            <div className='mx-auto flex max-w-7xl flex-col gap-10 px-5 py-14 sm:px-8 md:flex-row md:items-start md:justify-between'>
                <div className='max-w-sm'>
                    <Logo />
                    <p className='mt-4 text-sm leading-relaxed text-muted-foreground'>
                        21 AI agents that market your product, fill your pipeline, write your emails and fix your bugs. One Coordinator runs them all.
                    </p>
                </div>

                <nav aria-label='Footer'>
                    <ul className='grid grid-cols-2 gap-x-10 gap-y-3 sm:flex sm:gap-8'>
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a href={link.href} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                                    {link.label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a href='#demo' className='text-sm font-medium text-primary transition-opacity hover:opacity-80'>
                                Book a demo
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className='border-t border-white/[0.06]'>
                <p className='mx-auto max-w-7xl px-5 py-6 text-xs text-muted-foreground sm:px-8'>
                    &copy; <span suppressHydrationWarning>{new Date().getFullYear()}</span> {siteConfig.name}. All rights reserved.
                </p>
            </div>
        </footer>
    )
}

export default SiteFooter
